"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;
require("antd/lib/dropdown/style");
var _dropdown = _interopRequireDefault(require("antd/lib/dropdown"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/menu/style");
var _menu = _interopRequireDefault(require("antd/lib/menu"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _ = require("./..");
var _utils = require("../../utils");
var _components = require("../../components");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Profile = function Profile(props) {
  var _user$profile;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user,
    logout = _useAuth.logout,
    isAuthenticated = _useAuth.isAuthenticated,
    loginWithRedirect = _useAuth.loginWithRedirect;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  var _useAllowedForRoles = (0, _utils.useAllowedForRoles)([_utils.UserRoles.Admin, _utils.UserRoles.SuperAdmin]),
    isAdmin = _useAllowedForRoles.isAllowed;
  var toggleMenu = function toggleMenu() {
    setShowMenu(!showMenu);
  };
  var isClinicianUser = (0, _utils.isClinician)(user);
  var headerMenu = /*#__PURE__*/_react.default.createElement(_menu.default, null, !isAdmin && /*#__PURE__*/_react.default.createElement(_menu.default.Item, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/settings/profile"
  }, "My profile")), !props.hideChangePassword && /*#__PURE__*/_react.default.createElement(_menu.default.Item, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: isClinicianUser ? '/settings/settings' : '/change-password'
  }, "Change Password")), /*#__PURE__*/_react.default.createElement(_menu.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    className: "btn-link",
    onClick: function onClick() {
      return (0, _utils.showLogoutConfirm)(logout);
    }
  }, "Log out")));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isAuthenticated ? /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    onClick: function onClick() {
      return loginWithRedirect({});
    }
  }, "Log in") : /*#__PURE__*/_react.default.createElement("div", {
    className: "monument-user-menu py-[10px]"
  }, /*#__PURE__*/_react.default.createElement(_dropdown.default, {
    overlay: headerMenu,
    trigger: ['click'],
    onClick: toggleMenu
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "border-none bg-transparent flex items-center cursor-pointer"
  }, /*#__PURE__*/_react.default.createElement(_components.Avatar, {
    size: 48,
    imageId: (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.image,
    name: (0, _utils.personName)(user.profile),
    isCdnImage: isClinicianUser
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('mx-[12px] tw-label-regular max-w-[200px] ellipsis-text text-black')
  }, (0, _utils.personName)(user.profile)), /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: showMenu ? 'caret-up-heavy-16' : 'caret-down-heavy-16',
    className: "text-white"
  })))));
};
exports.Profile = Profile;